import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { FetchHandler } from "../../Handlers/FetchHandler";
import { ForumPostCard } from "../Forum/ForumPostCard";
import { AdminIcons } from "../Shared/AdminIcon";
import { ToolBar } from "../ToolBar/ToolBar";
import { LoadingBar, ScreenHeader, ScreenMenu } from "../UI/Elements";
import { JwtImage, JwtPlantImage, JwtPlantImageWithPreview } from "../UI/ImageElements";
import { useElasticMenu } from "./useElasticMenu";
import { useElasticSearch } from "./useElasticSearch";
import { ApprovedOriginsForPlantType, usePlantOrigins } from "../PlantOrigins/usePlantOrigins";
import { Dialog } from "../Shared/Dialog";

export const ElasticSearchPlants = () => {
    const ui = useElasticSearch();

    const origins = usePlantOrigins();

    // useEffect(() => {
    //     ui.load();
    // }, []);


    const menu = useElasticMenu();

    const [originsData, setOriginsData] = useState<ApprovedOriginsForPlantType>();
    const onOriginClick = async (id: string) => {
        const d = await origins.getApprovedOriginsForPlant(id);
        setOriginsData(d);
    }
    return (
        <div className="screen-elastic">
            <ScreenHeader text="Appsök växt med Elastic Search" icon={AdminIcons.leaf} />
            <ScreenMenu items={menu?.items} />

            <LoadingBar loading={ui.loadingPlants} />
            <div>
                <input placeholder="Sök..." className="frm" type={"search"} value={ui.searchPlants ?? ""} onChange={e => ui.setSearchPlants(e.target.value)} onKeyUp={e => {
                    if (e.key == "Enter") {
                        ui.onSearchPlants(ui.searchPlants, { filterOutSort: ui.elasticcheck_filterout_checked });
                    }
                }} />
                <span>
                    <input type="checkbox" name="elasticcheck_filterout" id="elasticcheck_filterout"
                        checked={ui.elasticcheck_filterout_checked}
                        onClick={() => ui.setElasticcheck_filterout_checked(!ui.elasticcheck_filterout_checked)}
                        onChange={() => { }}
                    />
                    <label htmlFor="elasticcheck_filterout">Ta inte med växter med sort</label>
                </span>
            </div>

            <div>
                <div>
                    Träffar: {ui?.plants?.total ?? 0} - Svarstid: {ui.plants?.durationms} ms.
                </div>
                <div>

                    {(ui.plants?.suggestions?.length > 0) && (
                        <div className="suggestions-container">
                            <label>
                                Menade du?
                            </label>

                            <div className="suggestions">
                                {(ui.plants?.suggestions?.length > 0) && ui.plants?.suggestions?.map(s => (
                                    <div className="suggestion" key={s} onClick={() => {
                                        ui.onSearchPlants(s);
                                        ui.setSearchPlants(s);
                                    }} >
                                        {s}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                </div>
                <table className="tbl tbl-small">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Namn</th>
                            <th>Sort</th>
                            <th>Latin</th>
                            <th>Alt nyckelord</th>
                            <th>Typ</th>
                            <th>Info</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {ui.plants?.hits?.map(hit => (
                            <tr key={hit?.Id}>
                                <td className="img">
                                    <JwtPlantImageWithPreview imageId={hit?.imageid} />
                                </td>
                                <td>
                                    <Link to={"/plants/edit/" + hit.id}>
                                        <div>
                                            {hit?.name}
                                        </div>
                                        <div className="text-s">
                                            {hit?.alternativenames}
                                        </div>
                                    </Link>
                                </td>
                                <td>
                                    <div>
                                        {hit?.specifictype}
                                    </div>
                                    <div className="text-s">
                                        {hit?.alternativename_type}
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        {hit?.namelatin}
                                    </div>
                                    <div className="text-s">
                                        {hit?.alternativename_latin}
                                    </div>
                                </td>
                                <td>{hit?.alternativekeywords}</td>
                                <td>{hit?.Type}</td>
                                <td>
                                    <div className="text-s">
                                        Score: {hit?.["__score__"]}<br />
                                        Sorting: {hit?.__sorting__}<br />
                                    </div>
                                </td>
                                <td>
                                    <button className="btn-link" onClick={() => onOriginClick(hit?.id)}>
                                        Ursprung
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <Dialog visible={!!originsData}
                    onCancel={() => setOriginsData(undefined)}
                >
                    <div className="origin-dialog">
                        <h3>
                            Ursprung
                        </h3>
                        <div className="origin-dialog-hits">
                            {originsData?.origins?.map(o => (
                                <div key={o.id}>
                                    {o.name} : {o.count} st
                                </div>
                            ))}
                        </div>
                        <h3>
                            Övrigt
                        </h3>
                        <div className="origin-dialog-misses">
                            {originsData?.misses?.map(o => (
                                <div key={o}>
                                    {o}
                                </div>
                            ))}
                        </div>
                    </div>
                </Dialog>
            </div>
        </div>
    )
}
